import React from 'react';
import KimSummary from '../../layout/KimGroup/KimSummary';
import PageLayout from '../../layout/PageLayout';

const KimSummaryPage: React.FC = () => (
  <PageLayout>
    <KimSummary />
  </PageLayout>
);

export default KimSummaryPage;
